import React, { useMemo } from 'react'
import { Helpers } from '../../../utils/helper';

interface FilesSelectionContainerProps{
  size?:number;
  children?:React.ReactNode;
}

function FileSelectionContainer({size=0,...props}:FilesSelectionContainerProps) {

  const formatSize = useMemo(()=>{
    return Helpers.formatBytesToMB(size);
  },[size])

  if(!props.children){
    return <></>
  }
  return (
    <div className='polymer-file-selection-container'>
      {props.children}
      <p>Total file size: <span className='size'>{formatSize}MB</span>/10MB</p>
    </div>
  )
}

export default FileSelectionContainer